export default __webpack_public_path__ + "assets/icon-replacement.87373f7c.webp";